import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../Components/InnerLayout/Headerbar";
import UserInterface from "../../Components/InnerLayout/UserInterface";
const Shift = (params) => {
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />
        <div className="inner-content">
          <div className="container px-0">
            <div className="shadowclass no-bg px-0 mt-0">
              <div className="top-header-sec mt-3">
                <h4 className="event-alert pt-0">
                  Shifts
                  <div className="clear"></div>
                </h4>
                <div className="row justify-content-between align-items-center w-100 mx-0">
                  <div className="col-lg-4 col-md-5 px-0 mb-3 mb-sm-0">
                    <div className="search-box mt-0">
                      <form type="GET">
                        <input
                          type="text"
                          placeholder="Search"
                          name="keyword1"
                        />
                        <input type="submit" />
                      </form>
                    </div>
                  </div>

                  <div className="btns col-sm-7 col-12 align-right px-0 d-flex align-items-center justify-content-end">
                    <div className="field text-right">
                      <button
                        class="btn green-btn-revert add-plus mx-0"
                        id="addCount"
                        type="button"
                      >
                        <i class="i-icon"> </i> Add Shift
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="accordion" id="accordionPanelsStayOpenExample">
              <div className="accordion-item">
                <h2
                  className="accordion-header"
                  id="panelsStayOpen-headingNine2"
                >
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseNine2"
                    aria-expanded="true"
                    aria-controls="panelsStayOpen-collapseNine2"
                  >
                    <div className="col d-flex align-items-center justify-content-between">
                      <h4 className="event-alert p-0 mb-0">Pending Shifts</h4>
                    </div>
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseNine2"
                  className="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-headingNine2"
                >
                  <div className="row mx-0 pendingShiftMs">
                    <div className="container px-0">
                      <div className="shadowclass mt-0">
                        <div className="col-lg-4 col-md-5 px-0 mb-3 mb-sm-0">
                          <div className="search-box mt-0">
                            <form type="GET">
                              <input
                                type="text"
                                placeholder="Search"
                                name="keyword1"
                              />
                              <input type="submit" />
                            </form>
                          </div>
                        </div>
                        <div className="table-responsive">
                          <table className="checklist-table remove-space ingredTable">
                            <thead>
                              <tr>
                                <th className="min-wd-200">Request Type</th>
                                <th class="avtar-th"></th>
                                <th>
                                  Requestor <br /> <i>Requestee</i>{" "}
                                </th>
                                <th>
                                  Shift Date (Out)
                                  <br /> <i>Shift Date (In)</i>
                                </th>
                                <th>
                                  Start Time (Out)
                                  <br /> <i>Start Time (In)</i>
                                </th>
                                <th>
                                  End Time (Out)
                                  <br /> <i>End Time (In)</i>
                                </th>
                                <th>
                                  Function
                                  <br /> <i>Function</i>
                                </th>
                                <th className="min-wd-250">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <span class="purple_tag">
                                    {" "}
                                    <i class="owner_icon tag_ico"></i> Need
                                    Owner{" "}
                                  </span>
                                </td>
                                <td class="avtar_pic">
                                  <figure class="reqstr">
                                    <img
                                      src="/img/no-image-found.png"
                                      id="preview"
                                      alt=""
                                    />{" "}
                                  </figure>
                                </td>
                                <td>
                                  <b>Johnny</b>
                                  <br />
                                  (Jasone's Shack!)
                                </td>
                                <td>Jul 11, 2022 </td>
                                <td>11:00am</td>
                                <td>01:00pm</td>
                                <td>Service</td>

                                <td class="actions_sec">
                                  <a
                                    href="/shifts/edit_shift_individual/10310"
                                    class="circle_icon"
                                  >
                                    <i class="iconSprites eye-icon"> </i>
                                  </a>
                                  <a
                                    href="#_"
                                    class="circle_icon red cancel_shift"
                                    val="10310"
                                  >
                                    <i class="iconSprites cancel-icon"> </i>
                                  </a>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2
                  className="accordion-header"
                  id="panelsStayOpen-headingNine3"
                >
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseNine3"
                    aria-expanded="true"
                    aria-controls="panelsStayOpen-collapseNine3"
                  >
                    <div className="col d-flex align-items-center justify-content-between">
                      <h4 className="event-alert p-0 mb-0">Upcoming Shifts</h4>
                    </div>
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseNine3"
                  className="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-headingNine3"
                >
                  <div className="row mx-0 upcomingShiftMs">
                    <div className="container px-0">
                      <div className="shadowclass mt-0">
                        <div className="col-lg-4 col-md-5 px-0 mb-3 mb-sm-0">
                          <div className="search-box mt-0">
                            <form type="GET">
                              <input
                                type="text"
                                placeholder="Search"
                                name="keyword1"
                              />
                              <input type="submit" />
                            </form>
                          </div>
                        </div>
                        <div className="table-responsive">
                          <table className="checklist-table remove-space ingredTable">
                            <thead>
                              <tr>
                                <th class="pic">&nbsp;</th>
                                <th>Shift Owner</th>
                                <th>
                                  <i>Shift Date</i>
                                </th>
                                <th>
                                  <i>Start Time</i>
                                </th>
                                <th>
                                  <i>End Time</i>
                                </th>
                                <th>
                                  <i>Function (In)</i>
                                </th>
                                <th class="blank d-lg-none d-xl-table-cell"> </th>
                                <th className="min-wd-250">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="avtar_pic">
                                  <figure>
                                    <img
                                      src="/img/no-image-found.png"
                                      id="preview"
                                      alt=""
                                    />{" "}
                                  </figure>
                                </td>
                                <td>
                                  <b>Joseph Lim</b>
                                  <br />
                                  Head Chef
                                </td>
                                <td>Jul 11, 2022</td>
                                <td>02:56pm</td>
                                <td>03:00pm</td>
                                <td>Kitchen</td>

                                <td className="d-lg-none d-xl-table-cell"> </td>
                                <td class="actions_sec">
                                  <a
                                    href="/shifts/edit_shift_individual/10352"
                                    class="circle_icon"
                                  >
                                    <i class="iconSprites eye-icon"> </i>
                                  </a>
                                  <a
                                    href="#_"
                                    class="circle_icon swap_shift"
                                    val="10352"
                                  >
                                    <i class="iconSprites shuffle-icon"> </i>
                                  </a>
                                  <a
                                    href="#_"
                                    class="circle_icon giveup_shift"
                                    val="10352"
                                  >
                                    <i class="iconSprites reply-icon"> </i>
                                  </a>
                                  <a
                                    href="#_"
                                    class="circle_icon red cancel_shift"
                                    val="10352"
                                  >
                                    <i class="iconSprites cancel-icon"> </i>
                                  </a>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default Shift;
